
import React from "react";
import { reactElement, reactApi } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { ImageViewer } from "../../Components/ImageViewer.js";
import { unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { ofArray, append as append_1, mapIndexed, map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";

export function ClickableImageStrip(props) {
    let elems;
    const patternInput = reactApi.useState(undefined);
    const setActiveIndex = patternInput[1];
    const activeIndex = patternInput[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-2"])], (elems = toList(delay(() => append(singleton(ImageViewer({
        ActiveIndex: unwrap(activeIndex),
        Images: map((image) => ({
            Src: image.Url,
        }), props.Images),
        IsOpen: activeIndex != null,
        OnClose: () => {
            setActiveIndex(undefined);
        },
    })), delay(() => mapIndexed((index, image_1) => reactElement("img", createObj(toList(delay(() => append(singleton(["className", join(" ", append_1(ofArray(["cursor-pointer", "object-cover"]), props.ImageClasses))]), delay(() => append(singleton(["src", image_1.Url]), delay(() => {
        let matchValue;
        return append((matchValue = image_1.Title, (matchValue == null) ? (empty()) : singleton(["title", matchValue])), delay(() => singleton(["onClick", (_arg_1) => {
            setActiveIndex(index);
        }])));
    })))))))), props.Images))))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

